import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrderHistory } from "../../store/slices/OrderSlice/OrderSlice";
import Badge from "../atoms/Badge/Badge";
import { ORDER_STATUS } from "../../helpers/const";
import { Link } from "react-router-dom";

const headers = [
  { title: "Order#", visible: true, className: "" },
  { title: "PO#", visible: true, className: "" },
  { title: "Date", visible: true, className: "" },
  { title: "Status", visible: true, className: " text-end" },
];

export default function OrderHistory() {
  const { orderHistory } = useSelector((state) => state.orders);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrderHistory());
  }, [dispatch]);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <div className="flex items-center gap-4">
            <h1 className="text-base font-semibold text-gray-900">
              Order History
            </h1>
            <Link
              to="/view-history"
              className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
            >
              View all →
            </Link>
          </div>
          <p className="mt-2 text-sm text-gray-700">
            Click on the order number to view details.
          </p>
        </div>
      </div>
      <div className="-mx-4 mt-10 bg-white/40 sm:mx-0 sm:rounded-lg ring-1 ring-gray-200 shadow-sm">
        <table className="min-w-full divide-y divide-gray-300 ">
          <thead>
            <tr>
              {headers
                .filter((txt, idx) => txt.visible)
                .map((head, idx) => {
                  return (
                    <th
                      key={idx}
                      id={head.title}
                      scope="col"
                      className={
                        "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" +
                        head.className
                      }
                    >
                      {head.title}
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody>
            {orderHistory?.length > 0 ? (
              orderHistory?.map((order, idx) => {
                return (
                  <tr key={idx} className="even:bg-gray-50">
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <Link
                        to={`/view-order/${order.customer_order_num}`}
                        className="font-bold hover:cursor-pointer hover:underline"
                      >
                        {order.customer_order_num}
                      </Link>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {order.customer_po}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {order.date_of_order}
                    </td>
                    <td className="pwhitespace-nowrap px-3 py-4 text-sm text-gray-500 text-end">
                      <Badge
                        text={
                          ORDER_STATUS.find(
                            (status) => status.id === order.status
                          )?.label
                        }
                        color={
                          ORDER_STATUS.find(
                            (status) => status.id === order.status
                          )?.color
                        }
                      />
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                {headers
                  ?.filter((txt) => txt.visible)
                  .map((txt, idx) => {
                    return (
                      <td
                        key={idx}
                        className="flex-1 space-y-6 py-2 animate-pulse"
                      >
                        <div className="h-2 rounded bg-gray-200"></div>
                      </td>
                    );
                  })}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
